import { BrowserRouter, Routes, Route, useNavigate, useParams, useLocation } from "react-router-dom";
import VoiceAgentWidget from "./components/VoiceAgent/VoiceAgentWidget";
import Navbar from "./components/Navbar";
import Homepage from "./pages/Homepage";
import OurServicesPage from "./pages/OurServicespage";
import BlogAndArticlesPage from "./pages/Blogandarticlespage";
import BlogArticleDetailPage from "./pages/Blogarticledetailpage";
import FaqsPage from "./pages/FaqsPage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactPage from "./pages/ContactPage";
import QuotePage from "./pages/QuotePage";
import AdminLogin     from "./pages/admin/AdminLogin";
import AdminLayout    from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminQuotes         from "./pages/admin/AdminQuotes";
import AdminConsultations  from "./pages/admin/AdminConsultations";
import AdminContacts          from "./pages/admin/AdminContacts";
import AdminServiceRequests  from "./pages/admin/AdminServiceRequests";
import AdminTestimonials     from "./pages/admin/AdminTestimonials";
import ProtectedRoute from "./components/ProtectedRoute";
import TestimonialPage from "./pages/Testimonialpage";
import TrackQuotePage  from "./pages/TrackQuotePage";
import OurProcessPage    from "./pages/OurProcessPage";
import ConsultationPage    from "./pages/ConsultationPage";
import ServiceRequestPage  from "./pages/ServiceRequestPage";
import MediaPage from "./pages/Mediapage";
import AdminBlog         from "./pages/admin/AdminBlog";
import AdminVoiceAgent   from "./pages/admin/AdminVoiceAgent";
import AdminNewsletter   from "./pages/admin/AdminNewsletter";
import AdminSettings     from "./pages/admin/AdminSettings";
import AdminLoginLogs    from "./pages/admin/AdminLoginLogs";
import AdminClientView   from "./pages/admin/AdminClientView";
import AdminSchedule     from "./pages/admin/AdminSchedule";
import AdminAnalytics    from "./pages/admin/AdminAnalytics";
import AppointmentPage   from "./pages/AppointmentPage";
import VideoCallPage      from "./pages/VideoCallPage";
import NotFoundPage          from "./pages/NotFoundPage";
import TestimonialSubmitPage from "./pages/TestimonialSubmitPage";
import ReferralProgramPage from "./pages/ReferralProgramPage";
import AdminReferrals from "./pages/admin/AdminReferrals";

function VoiceWidgetGuard() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  return <VoiceAgentWidget />;
}

function BlogListWrapper() {
  const navigate = useNavigate();
  return <BlogAndArticlesPage onNavigate={(slug) => navigate(`/blog/${slug}`)} />;
}

function BlogDetailWrapper() {
  const navigate = useNavigate();
  const { slug } = useParams();
  return (
    <BlogArticleDetailPage
      slug={slug}
      onBack={() => navigate("/blog")}
      onNavigate={(newSlug) => navigate(`/blog/${newSlug}`)}
    />
  );
}

function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPage = location.pathname.replace("/", "") || "home";

  return (
    <>
      <Navbar
        setPage={(page) => navigate(`/${page === "home" ? "" : page}`)}
        currentPage={currentPage}
      />
      {children}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <VoiceWidgetGuard />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Homepage />
            </Layout>
          }
        />
        <Route
          path="/services"
          element={
            <Layout>
              <OurServicesPage />
            </Layout>
          }
        />
        <Route
          path="/media"
          element={
            <Layout>
              <MediaPage />
            </Layout>
          }
        />
        <Route
          path="/blog"
          element={
            <Layout>
              <BlogListWrapper />
            </Layout>
          }
        />
        <Route
          path="/blog/:slug"
          element={
            <Layout>
              <BlogDetailWrapper />
            </Layout>
          }
        />
        <Route
          path="/faqs"
          element={
            <Layout>
              <FaqsPage />
            </Layout>
          }
        />
        <Route
          path="/why-paladin"
          element={
            <Layout>
              <AboutUsPage />
            </Layout>
          }
        />
        <Route
          path="/our-process"
          element={
            <Layout>
              <OurProcessPage />
            </Layout>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <ContactPage />
            </Layout>
          }
        />
        <Route
          path="/quote"
          element={
            <Layout>
              <QuotePage />
            </Layout>
          }
        />

        {/* ── Admin (no public Navbar) ── */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="quotes"          element={<AdminQuotes />} />
          <Route path="consultations"   element={<AdminConsultations />} />
          <Route path="contacts"        element={<AdminContacts />} />
          <Route path="service-requests" element={<AdminServiceRequests />} />
          <Route path="testimonials"    element={<AdminTestimonials />} />
          <Route path="blog"            element={<AdminBlog />} />
          <Route path="voice-agent"     element={<AdminVoiceAgent />} />
          <Route path="newsletter"      element={<AdminNewsletter />} />
          <Route path="settings"        element={<AdminSettings />} />
          <Route path="login-logs"      element={<AdminLoginLogs />} />
          <Route path="client-view"     element={<AdminClientView />} />
          <Route path="schedule"        element={<AdminSchedule />} />
          <Route path="analytics"       element={<AdminAnalytics />} />
          <Route path="referrals"       element={<AdminReferrals />} />
        </Route>

        <Route
          path="/testimonial"
          element={
            <Layout>
              <TestimonialPage />
            </Layout>
          }
        />
        <Route
          path="/consultation"
          element={
            <Layout>
              <ConsultationPage />
            </Layout>
          }
        />
        <Route
          path="/service-request"
          element={
            <Layout>
              <ServiceRequestPage />
            </Layout>
          }
        />
        <Route
          path="/referral"
          element={
            <Layout>
              <ReferralProgramPage />
            </Layout>
          }
        />
        <Route
          path="/track"
          element={
            <Layout>
              <TrackQuotePage />
            </Layout>
          }
        />
        <Route
          path="/submit-testimonial"
          element={
            <Layout>
              <TestimonialSubmitPage />
            </Layout>
          }
        />
        <Route
          path="/appointment"
          element={
            <Layout>
              <AppointmentPage />
            </Layout>
          }
        />

        {/* Standalone — no navbar, full-screen video call */}
        <Route path="/video-call" element={<VideoCallPage />} />

        <Route
          path="*"
          element={
            <Layout>
              <NotFoundPage />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}